<template>
  <div>

    <v-row class="mb-5">
      <v-col cols="8" md="6">
        <v-text-field
            v-model="wholesaler_serch_query"
            :placeholder="$lang.WHOLESALER_SEARCH"
            append-icon="mdi-magnify"
            dense
            hide-details
            outlined
            rounded
            @keyup="getWholesalerList"
        ></v-text-field>
      </v-col>
      <v-col class="text-right" cols="4" md="6">
				<span class="cursor-pointer" @click="$router.push({name:'add-a-wholesaler'})">
					<span class="secodry-text-4 mr-3 ">{{ $lang.ADD_A_WHOLESALER.toUpperCase() }}</span>
					<v-btn color="primary" depressed fab small>
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</span>
      </v-col>
    </v-row>

    <div>
      <v-data-table
          :disable-sort="true"
          :headers="headers"
          :hide-default-footer="true"
          :items="wholesaler_list"
          :items-per-page="$keys.PAGE_LENGTH"
          :loading="table_loading"
          class="elevation-1 custome-header-bg custome-table-body"
      >

        <template v-slot:item.firm_name="{ item }">
          <p>{{ item.firm_name }}</p>
          <p>{{ $lang.MOBILE_PREFIX }}{{ item.mobile }}</p>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn fab small text @click="gotowholesalerDetails(item)">
            <img alt="" src="@/assets/arrow-right.svg">
          </v-btn>
        </template>
        <template v-slot:item.pickup_agent="{ item }">

          <p>{{ item.pickup_agent_name }}</p>
          <p v-if="item.pickup_agent_mobile_number">{{ $lang.MOBILE_PREFIX }}{{ item.pickup_agent_mobile_number }}</p>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn fab small text @click="gotowholesalerDetails(item)">
            <img alt="" src="@/assets/arrow-right.svg">
          </v-btn>
        </template>

        <!--  -->
        <!-- <template v-slot:item.reminder>
          <div >
            <v-btn fab small depressed text>
              <img src="@/assets/send.svg" alt="">
            </v-btn>
          </div>
        </template>	 -->
        <!-- empty slot  -->
        <template v-slot:no-data>
          <empty-list :message="$lang.EMPTY_WHOLESALER" :type="$keys.EMPTY_TYPE_2"/>
        </template>

      </v-data-table>

      <v-pagination v-model="page_number" :length="total_page_count" :total-visible="7" class="custome-pagination"
                    @input="getWholesalerList"></v-pagination>

    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  components: {},

  data() {
    return {
      is_active: false,
      total_page_count: 1,
      page_number: 1,
      table_loading: false,
      wholesaler_serch_query: "",
      wholesaler_list: [],
      headers: [
        {text: 'Name', align: 'start', value: 'firm_name'},
        {text: 'Address', value: 'full_address'},
        {text: 'Days Left', value: 'days_left'},
        {text: 'Pickup agent', value: 'pickup_agent'},
        // { text: 'Reminder', value: 'reminder' },
        {text: '', value: 'action'},
      ],

    }
  },
  created() {
    this.$store.dispatch('setPageLoader', true)
    this.getWholesalerList(false)
  },
  methods: {
    /* fetching shipment list */
    getWholesalerList(is_cancel = true) {
      const self = this
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.wholesaler_serch_query,
      };
      self.table_loading = true

      const successHandler = (response) => {
        if (response.data.success) {
          this.wholesaler_list = response.data.wholesaler_list
          this.total_page_count = response.data.total_page_count
        }
      };
      const finallyHandler = () => {
        self.table_loading = false
        this.$store.dispatch('setPageLoader', false)
      };

      self.request_GET(self, self.$urls.WHOLESALER_LIST, params, successHandler, null, null, finallyHandler, is_cancel)
    },
    ChangeWholesalerVerificationStatus(item) {
      console.log(item)
      const self = this;
      self.btn_loding = true
      var form = new FormData();
      let is_active = "False"
      if (item.is_active)
        is_active = "True"

      form.append("wholesaler_id", item.wholesaler_id);
      form.append("is_active", is_active);

      const successHandler = (response) => {
        if (response.data.success) {
          this.getWholesalerList()
        }
      };
      const finallyHandler = () => {
        self.btn_loding = false
      };

      this.request_POST(self, this.$urls.WHOLESALER_CHANGE_VERIFIACATION_STATUS, form, successHandler, null, null, finallyHandler)
    },
    gotowholesalerDetails(item) {
      console.log(item)
      this.$router.push({name: 'wholesaler-details', params: {wholesaler_id: this.encript(item.wholesaler_id)}})

    },

  }
}


</script>